import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LangContext";
import { FAQS } from "@/content/seoContent";
import { HelpCircle, ArrowLeft } from "lucide-react";

const COPY = {
  it: { title: "Domande Frequenti", sub: "Tutto quello che c'è da sapere su PDF, conversioni, OCR e sicurezza dei dati su Dotec EW-PDF.", back: "Torna alla home" },
  en: { title: "Frequently Asked Questions", sub: "Everything you need to know about PDFs, conversions, OCR and data security on Dotec EW-PDF.", back: "Back to home" },
  es: { title: "Preguntas Frecuentes", sub: "Todo lo que hay que saber sobre PDF, conversiones, OCR y seguridad de los datos en Dotec EW-PDF.", back: "Volver al inicio" },
  fr: { title: "Questions Fréquentes", sub: "Tout ce qu'il faut savoir sur les PDF, les conversions, l'OCR et la sécurité des données sur Dotec EW-PDF.", back: "Retour à l'accueil" },
  de: { title: "Häufige Fragen", sub: "Alles Wissenswerte über PDFs, Konvertierungen, OCR und Datensicherheit bei Dotec EW-PDF.", back: "Zurück zur Startseite" },
};

export default function Faq() {
  const { lang } = useLang();
  const l = COPY[lang] ? lang : "en";
  const faqs = FAQS[l] || FAQS.en;
  const c = COPY[l];

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "faq-jsonld";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
    document.head.appendChild(script);
    return () => document.getElementById("faq-jsonld")?.remove();
  }, [faqs]);

  return (
    <div className="mx-auto max-w-4xl px-6 py-12 lg:px-8" data-testid="faq-page">
      <div className="mb-6 flex justify-start">
        <Link to="/" data-testid="back-home-link" className="group inline-flex items-center gap-2 rounded-full border-2 border-emerald-500 bg-emerald-50 px-5 py-2.5 text-sm font-bold text-emerald-700 shadow-sm transition-all hover:-translate-y-0.5 hover:bg-emerald-500 hover:text-white hover:shadow-md">
          <ArrowLeft className="h-4 w-4 transition-transform group-hover:-translate-x-1" />
          {c.back}
        </Link>
      </div>
      <div className="mb-10 text-center">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-emerald-100 text-emerald-600">
          <HelpCircle className="h-7 w-7" />
        </div>
        <h1 className="font-display text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">{c.title}</h1>
        <p className="mx-auto mt-3 max-w-2xl text-slate-500">{c.sub}</p>
      </div>

      <div className="space-y-6">
        {faqs.map((f, i) => (
          <article key={i} data-testid={`faq-item-${i}`} className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
            <h2 className="font-display text-lg font-bold text-slate-900">{f.q}</h2>
            <p className="mt-3 text-base leading-relaxed text-slate-600">{f.a}</p>
          </article>
        ))}
      </div>
    </div>
  );
}
